import React from 'react';
import { selectJobStages } from '../../../redux/selectors/constantsSelectors';
import TableStatus, { TableStatusProps } from './TableStatus';
import { useAppSelector } from '@/redux/hooks';

const TableJobStage = (props: TableStatusProps) => {
  const stages = useAppSelector(selectJobStages);

  return <TableStatus {...props} customStatuses={stages} />;
};

export default TableJobStage;
